
export const Courses =[

  {
    "id":1,
    "course_name":'Cloud, DevOps + AI Certification Program',
    "course_img":"https://ik.imagekit.io/microdegree/Main%20Website%20Videos/aws3_HBtJdD14S.png?updatedAt=1716118967038",
    // "course_link":"https://tally.so/r/wvrq48",
    "course_link":'https://www.microdegree.work/awsdevops',
    "course_desc":"Master AWS and DevOps with our premium course, projected to be in highest demand for jobs in 2024. Boost your career with expert-led instruction and practical skills in Cloud Computing and DevOps",
    "course_category":'Premium',
    // "course_price":'Coming Soon',
    "course_price":'22,500',
    "url":"https://www.microdegree.work/awsdevops",
    "course_status":['Working Professionals'],
    course_details:["60 Hrs of LIVE Online Training",
    "Concepts Explained in Kannada",
    "Completion Certificate",
    "Build Interactive Projects",
    "Doubt Clarification",
    "Interview Preparation",
    "Career Assistance",
  ],
},

  {
    "id":1,
    "course_name":'Generative AI & Agentic AI Certification Program',
    "course_img":"https://ik.imagekit.io/microdegree/Main%20Website%20Videos/aws3_HBtJdD14S.png?updatedAt=1716118967038",
    // "course_link":"https://tally.so/r/wvrq48",
    "course_link":'https://www.microdegree.work/genai',
    "course_desc":"Master AWS and DevOps with our premium course, projected to be in highest demand for jobs in 2024. Boost your career with expert-led instruction and practical skills in Cloud Computing and DevOps",
    "course_category":'Premium',
    // "course_price":'Coming Soon',
    "course_price":'22,500',
    "url":"https://www.microdegree.work/awsdevops",
    "course_status":['Working Professionals'],
    course_details:["60 Hrs of LIVE Online Training",
    "Concepts Explained in Kannada",
    "Completion Certificate",
    "Build Interactive Projects",
    "Doubt Clarification",
    "Interview Preparation",
    "Career Assistance",
  ],
},


]